import { OrderBilling } from './order-billing';

export class SplitPayment extends OrderBilling {
  splitAmount = 0;
}
